import { prefixerT } from '.'

export const ROUTE_BANDEJA_FLUJO_PAGO = prefixerT('bandeja-flujo-pago')
export const ROUTE_CREAR_FLUJO_PAGO = prefixerT('crear-flujo-pago')
export const ROUTE_BANDEJA_REVISION_FLUJO_PAGO = prefixerT('bandeja-revision-flujo-pago')
export const ROUTE_REVISION_FLUJO_PAGO = prefixerT('revision-flujo-pago')
export const ROUTE_APROBACION_FLUJO_PAGO = prefixerT('aprobacion-flujo-pago')
export const ROUTE_BANDEJA_TRANSACCIONES_BANCARIAS = prefixerT('bandeja-transaccion-bancaria')
export const ROUTE_CREAR_DEPOSITO = prefixerT('crear-deposito')
export const ROUTE_CREAR_TRANSFERENCIA = prefixerT('crear-transferencia')
export const ROUTE_CREAR_NOTA_CREDITO = prefixerT('crear-nota-credito')
export const ROUTE_CREAR_CHEQUE = prefixerT('crear-cheque')
export const ROUTE_CREAR_NOTA_DEBITO = prefixerT('crear-nota-debito')
export const ROUTE_CONCILIACION_BANCARIA = prefixerT('conciliacion-bancaria')
